import React from 'react';
import { Share } from 'react-bootstrap-icons';
import ShareModal from '../components/ShareModal/ShareModal';

export default function GLIFOSViewerTools(props) {
	//console.log(props);
	/* 	const [showTools, setShowTools] = useState(false); */
	//const [showShare, setShowShare] = useState(false);

	/* 	const handleCloseShare = () => setShowShare(false); */
	//const handleShow = () => setShowShare(true);

	/* const addBookmark = () => {
		if (window.sidebar) {
			// Mozilla Firefox Bookmark
			window.sidebar.addPanel(window.location.href, document.title, '');
		} else if (window.external) {
			// IE Favorite
			window.external.AddFavorite(window.location.href, document.title);
		} else if (window.opera && window.print) {
			// Opera Hotlist
			this.title = document.title;
			return true;
		}
	}; */

	return (
		<>
			{/* <Fade in={showTools}>
				<div id='example-collapse-text'>
					<div className='g-vw-tools'>
						<ul>
							{/* <li>
							<Search
								size={25}
								color='black'
								aria-label='Buscar dentro del documento'
							/>
						</li> * /}
							{/* <li>
							<Bookmark
								size={25}
								color='black'
								aria-label='Marcar Documento de Interés'
							/>
						</li> * /}
							<li>
								<Share
									size={25}
									color='black'
									aria-label='Compartir'
									data-bs-toggle='modal'
									data-bs-target={`#shareModal-${props.itemInfo?.isadg?.code}`}
									onClick={handleShow}
								/>
							</li>
							{/* <li>
							<Pencil
								size={25}
								color='black'
								aria-label='Comentario'
							/>
						</li>
						<li>
							<Cart
								size={25}
								color='black'
								aria-label='Solicitar Copia'
							/>
						</li>
						<li>
							<Calendar4Event
								size={25}
								color='black'
								aria-label='Hacer Cita'
							/>
						</li> * /}
							{/* <li>
								<QuestionLg
									size={25}
									color='black'
									aria-label='Ayuda'
								/>
							</li> * /}
						</ul>
					</div>
				</div>
			</Fade> */}
			{/* {showTools && (
				<div className='g-vw-tools'>
					<ul>
						{/* <li>
							<Search
								size={25}
								color='black'
								aria-label='Buscar dentro del documento'
							/>
						</li> */}
			{/* <li>
							<Bookmark
								size={25}
								color='black'
								aria-label='Marcar Documento de Interés'
							/>
						</li> * /}
			<li>
				<Share size={25} color='black' aria-label='Compartir' />
			</li>
			{/* <li>
							<Pencil
								size={25}
								color='black'
								aria-label='Comentario'
							/>
						</li>
						<li>
							<Cart
								size={25}
								color='black'
								aria-label='Solicitar Copia'
							/>
						</li>
						<li>
							<Calendar4Event
								size={25}
								color='black'
								aria-label='Hacer Cita'
							/>
						</li> * /}
						<li>
							<QuestionLg
								size={25}
								color='black'
								aria-label='Ayuda'
							/>
						</li>
					</ul>
				</div>
			)} */}
			<div
				className='g-vw-t d-flex justify-content-center align-items-center'
				//aria-controls='example-collapse-text'
				//aria-expanded={showTools}
				//onClick={() => setShowTools(!showTools)}
			>
				<Share
					size={30}
					color='white'
					aria-label='Compartir'
					data-bs-toggle='modal'
					data-bs-target={`#shareModal-${props.itemInfo?.isadg?.code}`}
					//onClick={handleShow}
				/>
				{/* {!showTools ? (
					<Wrench color='white' size={30} />
				) : (
					<XLg color='white' size={30} />
				)} */}
			</div>
			<ShareModal
				id={`shareModal-${props.itemInfo?.isadg?.code}`}
				url={`${window.location.origin}/glifos/item/${props.itemInfo?.isadg?.code}`}
				quote={props.itemInfo?.isadg?.display_name}
			/>
		</>
	);
}
